module.exports = __webpack_public_path__ + "img/main5.78cf23ae.png";